import React from 'react';
import ReactDOM from 'react-dom';
import './FooterCSS.css';

class FooterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style : {height: "auto"}

        };
    }

    printref = () => {
        console.log(this.cRef);
        console.log(this.cRef.offsetTop);
        console.log(window.innerHeight);
        console.log(this.cRef.clientHeight);
        console.log((window.innerHeight + this.cRef.offsetTop) - (this.cRef.clientHeight) );
    };

    // componentDidMount = () => {
    //     this.setState(Object.assign(this.state, {
    //         style : {marginTop: `${window.innerHeight - (this.cRef.clientHeight + this.cRef.offsetTop)}px`, height:"auto"}
    //     }))
    // };
    //
    // debounce = (fn, delay) => {
    //     var t;
    //     return function () {
    //         clearTimeout(t);
    //         t = setTimeout(fn, delay)
    //     }
    // };
    //
    // updateHeight = () => {
    //
    //    this.printref();
    //
    //     this.setState(Object.assign(this.state, {
    //         style : {marginTop: `${window.innerHeight - (this.cRef.clientHeight + this.cRef.offsetTop)}px`, height:"auto"}
    //     }))
    //
    //
    // };
    // componentWillMount = () => {
    //     window.addEventListener("resize", this.debounce(this.updateHeight, 200));
    //
    // };
    //
    // componentWillUnmount = () => {
    //     window.addEventListener("resize", this.debounce(this.updateHeight, 200));
    // };
    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.isShowing && !this.props.isShowing) {
    //         this.debounce(this.updateHeight, 200)()
    //     }
    // }


    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     this.setState(Object.assign(this.state, {
    //         style : {marginTop: `${window.innerHeight - (this.cRef.current.clientHeight + this.cRef.current.offsetTop)}px`, height:"auto"}
    //     }))
    // }

    render() {
        return (
            <div>
                <div ref={cRef => this.cRef = cRef} onClick={this.printref} className="row main-blue text-center pt-2 "
                     style={ this.state.style }>
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-2 p-0 align-self-center">
                                <img
                                    src="https://www.skyharbor.com/images/default-source/siteimages/logos/birdwhite-min.png"
                                    className="img-fluid m-1 p-1" style={{maxHeight: "50px"}}
                                    alt=""/>
                            </div>
                            <div className="col-9 d-md-none text-center align-self-center p-0 sh-footer">
                                <div className="row">
                                    <div className="col-12">
                                        <small><a href="/#">Careers</a> | <a href="/#">About</a> | <a
                                            href="/#">Media & Press Room</a></small>

                                    </div>
                                    <div className="col-12">
                                        <small>
                                            <a href="/#">Nondiscrimination</a> |
                                            <a href="/#">Privacy Policy</a>
                                        </small>

                                    </div>
                                    <div className="col-12">
                                        <small>City of Phoenix - Aviation Department | 2485 E. Buckeye Rd. Phoenix, AZ
                                            85034
                                            |
                                            602-273-3300
                                        </small>
                                        <br/>
                                        <small>©2018 Phoenix Sky Harbor International Airport. All rights reserved.
                                        </small>

                                    </div>

                                </div>


                            </div>
                            <div className="d-none d-md-flex col-12 col-md-9 text-center text-md-left legal-text">
                                <div className="row">
                                    <div>
                                        <small>City of Phoenix - Aviation Department | 2485 E. Buckeye Rd. Phoenix, AZ
                                            85034
                                            |
                                            602-273-3300
                                        </small>
                                    </div>
                                    <div>
                                        <small>©2018 Phoenix Sky Harbor International Airport. All rights reserved.
                                        </small>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-6 d-none d-md-block">
                        <div className="row">
                            <div className="col-12 text-right">
                                <small><a href="/#">Careers</a> | <a href="/#">About</a> | <a href="/#">Contact
                                    Us</a> | <a
                                    href="/#">Media & Press Room</a> | <a href="/#">Nondiscrimination</a> | <a
                                    href="/#">Privacy
                                    Policy</a></small>

                            </div>
                            <div className="col-12 mb-3 text-right">

                                <a href="https://www.facebook.com/PHXSkyHarbor">
                                    <img
                                        src="https://www.skyharbor.com/images/default-source/siteimages/iconssocialmedia/fb.png"
                                        className="img-fluid p-1"
                                        style={{maxHeight: "38px"}} alt=""/>
                                </a>
                                <a href="https://www.instagram.com/phxskyharbor/">
                                    <img
                                        src="https://www.skyharbor.com/images/default-source/siteimages/iconssocialmedia/insta.png"
                                        className="img-fluid p-1"
                                        style={{maxHeight: "38px"}} alt=""/>
                                </a>
                                <a href="https://www.linkedin.com/company/phoenix-sky-harbor-international-airport">
                                    <img
                                        src="https://www.skyharbor.com/images/default-source/siteimages/iconssocialmedia/li.png"
                                        className="img-fluid p-1"
                                        style={{maxHeight: "38px"}} alt=""/>
                                </a>
                                <a href="https://www.pinterest.com/phxskyharbor/">
                                    <img
                                        src="https://www.skyharbor.com/images/default-source/siteimages/iconssocialmedia/pin.png"
                                        className="img-fluid p-1"
                                        style={{maxHeight: "38px"}} alt=""/>
                                </a>
                                <a href="https://www.snapchat.com/add/PHXSkyHarbor">
                                    <img
                                        src="https://www.skyharbor.com/images/default-source/siteimages/iconssocialmedia/sc.png"
                                        className="img-fluid p-1"
                                        style={{maxHeight: "38px"}} alt=""/>
                                </a>
                                <a href="https://twitter.com/PHXSkyHarbor">
                                    <img
                                        src="https://www.skyharbor.com/images/default-source/siteimages/iconssocialmedia/twttr.png"
                                        className="img-fluid p-1"
                                        style={{maxHeight: "38px"}} alt=""/>
                                </a>
                                <a href="https://www.youtube.com/user/PhoenixSkyHarbor">
                                    <img
                                        src="https://www.skyharbor.com/images/default-source/siteimages/iconssocialmedia/yt.png"
                                        className="img-fluid p-1"
                                        style={{maxHeight: "38px"}} alt=""/>
                                </a>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        )
    }
}

let domContainer = document.querySelector('#footer-comp');

if (!(domContainer === undefined || domContainer === null) === true) ReactDOM.render(<FooterComponent/>, domContainer);